import React from 'react';
import { use100vh } from 'react-div-100vh';

import classnames from 'classnames';
import styles from './index.module.scss';

interface IProps {
    className?: string;
    text?:string;
}

const Message: React.FC<IProps> = ({
    className, text
}): JSX.Element => {
    const height = use100vh();
    const top = height ? height * 0.9 : '90vh';

    return <div className={classnames(className, styles.message)} style={{ top }}>{text}</div>;
};

Message.defaultProps = {
    className: '',
    text: ''
};
export default Message;
